export default {
    SET_PATH : 'SET_PATH',
    SET_EDIT_DATA: 'SET_EDIT_DATA'
};
